<template>

    <van-collapse v-model="activeNames" v-if="ht" accordion>
      <van-collapse-item title="对应销售合同" name="1">
        <xsht  :htid="ht.xshtid"></xsht>
        </van-collapse-item>
      <van-collapse-item title="预算详情" name="2">
        <van-cell title="预算单名字"  :label="ht.ysdmz" />
        <van-cell title="项目编号"  :value="ht.xmid" />
        <van-cell v-if="ht.kXm" title="项目名称" :label="ht.kXm.xmmc"  />
        <van-cell v-if="ht.startdate" title="开始时间" :value="U.parseTime(ht.startdate,'{y}-{m}-{d}')"  />
        <van-cell v-if="ht.enddate" title="结束时间" :value="U.parseTime(ht.enddate,'{y}-{m}-{d}')"  />
        <template  v-if="ht.ysgclist">
          <van-divider>具体工程统计</van-divider>
          <van-cell :key="'gc'+gc.id" v-for="gc in ht.ysgclist" :title="gc.gzxm"  >
               <template #label>
                 <span  style="margin: 1rem;">工作数量:{{gc.gzsl}}</span> <span  style="margin: 1rem;">工程量:{{gc.gcl}}</span>
               </template>
           </van-cell>
        </template>
        <template  v-if="ht.ysxhlist">
            <van-divider>具体预算项目</van-divider>
          <van-cell :key="'ysx'+ysx.id" v-for="ysx in ht.ysxhlist" :title="xzproduct(ysx.pid)" :value="ysx.ysje" >
               <template #label>
                 <span>税率:{{parseFloat(ysx.tax || 0)*100}}% | 税费:{{ysx.ssje || 0}}</span>
                 <span v-if="ysx.bz">备注:{{ysx.bz}}</span>
               </template>
           </van-cell>
        </template>
        <van-cell v-if="true" title="预算总金额" :value="ht.ysje"  />
          <van-cell v-if="true" title="预计毛利润" :value="ht.yjlr+'%'"  />
         <van-cell v-if="true" title="预算总成本" :value="ht.yscb"  />
         <van-cell v-if="true" title="总税费" :value="ht.ssje"  />
        <van-cell v-if="true" title="不含税成本" :value="ht.bhscb"  />
        <van-cell v-if="ht.fjwj" title="合同文件"  >
             <template #label>
               <Filedownload :srcs="ht.fjwj"></Filedownload>
             </template>
         </van-cell>

      </van-collapse-item>

    </van-collapse>

</template>

<script>
  // import {DictTag} from "@/components/DictTag/index"
  import Filedownload from '../../components/FileDownload/index.vue'
  import xsht from './xsht.vue'

  export default {
    name: 'ys',
    components: {
      xsht:xsht,
      Filedownload: Filedownload
    },
    props: {
      id: {
        type: String,
        default: null,
      },
      ht:{
        type:Object,
        default:null
      }
    },
    data () {
      return {
        activeNames:'2',
        dict: {type: []},
        dicts: ['xm_htjd', 'xm_hzxz', 'xm_yes_no', 'xm_htfjsx'],
        dataid: null,
        workid: null,
        products:[],
        dqlc:null,
        xsht:null,
        depts: [],
        shshow: false,
        loading: false,
        form: {
          dataid: null,
          shzt: 1,
          shyj: ''
        }

      }
    },
    created () {
      console.log("ys",this.ht)
      this.getdepts()
      this.getdicts()

      this.getproducts()
      this.getHt()
    },
    methods: {
      onClickLeft () {
        this.$router.go(-1)
      },
      xzproduct(pid){

        return this.U.chooseValueFromArr(this.products,'id',pid,'mz')
      },

      getdepts () {
        let that = this
        this.$ajax.get('/system/dept/list').then(res => {
          that.depts = res.data
        })
      },
      getproducts(){
        let that = this
        this.$ajax.get("/xm/product/kylist").then(res=>{

          that.products=res.data
        })
      },
      getdicts () {
        let that = this
        if (this.dicts.length > 0) {
          for (let d of this.dicts) {
            // console.log("d",d)
            this.$ajax.get('/system/dict/data/type/' + d).then(res => {
              that.dict.type[d] = res.data
              //  console.log(that.dict)
            })
          }
        }
      },
      getHt () {
        let that = this
        if(this.ht)return;
        else
        this.$ajax.get('/xm/ys/' + this.id).then(function (res) {
          if (res.code == 200) {
            that.ht = res.data


          }
        })
      },




    }
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Zsmb/ys.vue